import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';

import { Country } from '../_models/country';
import { State } from '../_models/state';

@Injectable()
export class CountriesService {
    private readonly apiController: string;

    constructor(private readonly httpClient: HttpClient) {
        this.apiController = `${environment.webApiUrl}/api/v${environment.webApiVersion}/countries`;
    }

    getCountries(): Observable<Country[]> {
        return this.httpClient.get<Country[]>(`${this.apiController}/getCountries`)
            .map(
                (countries: Country[]) => {
                    return countries;
                }
            );
    }

    getStateForAbbreviation(abbreviation: string): Observable<State> {
        return this.httpClient.get<State>(`${this.apiController}/getStateForAbbreviation?abbreviation=${abbreviation}`)
            .map(
                (state: State) => {
                    return state;
                }
            );
    }

    getStates(): Observable<State[]> {
        return this.httpClient.get<State[]>(`${this.apiController}/getStates`)
            .map(
                (states: State[]) => {
                    return states;
                }
            );
    }

    getStatesForCountry(countryId: number): Observable<State[]> {
        return this.httpClient.get<State[]>(`${this.apiController}/getStatesForCountry?countryId=${countryId}`)
            .map(
                (states: State[]) => {
                    return states;
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/countries.service.ts